import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const FacilitiesContracts = () => {
  return (
    <SettingsMetaData propertyName={"Facilities_Contracts"} viewPropertyName={"Facilities / Building"} />
  );
};
export default FacilitiesContracts;